/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'

const CompanySettingsSchema = new Schema({
  companyAddress: {
    type: 'string',
    maxLength: 255,
    required: true
  },
  companyEmail: {
    type: 'string',
    format: 'email',
    maxLength: 100
  },
  companyFinancialGuaranteeAmount: {
    type: 'string',
    maxLength: 16
  },
  companyFinancialGuaranteeFund: {
    type: 'string',
    maxLength: 100
  },
  companyLegalForm: {
    type: 'string',
    maxLength: 50,
    required: true
  },
  companyName: {
    type: 'string',
    maxLength: 100,
    required: true
  },
  companyPhone: {
    type: 'string',
    maxLength: 15
  },
  companyPostalAddress: {
    type: 'string',
    maxLength: 255
  },
  companyRcsNumber: {
    type: 'string',
    maxLength: 10
  },
  companyShareCapital: {
    type: 'string'
  },
  companyTahitiNumber: {
    type: 'string',
    maxLength: 10
  }
})

export default CompanySettingsSchema
